import { render, staticRenderFns } from "./clueDesignOwnerPage.vue?vue&type=template&id=867c152e"
import script from "./clueDesignOwnerPage.vue?vue&type=script&lang=js"
export * from "./clueDesignOwnerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports